module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.visible) ? _c('div', {
    staticClass: "search-loading-mask",
    style: (_vm.customStyle)
  }, [_c('div', {
    staticClass: "search-container"
  }, [_c('div', {
    staticClass: "search-wrap"
  }, [_c('div', {
    staticClass: "modern-document"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "document-content"
  }, _vm._l((5), function(i) {
    return _c('div', {
      key: i,
      staticClass: "content-line"
    })
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "document-footer"
  }, [_c('div', {
    staticClass: "footer-line"
  }), _vm._v(" "), _c('div', {
    staticClass: "footer-tags"
  }, _vm._l((3), function(i) {
    return _c('div', {
      key: 'tag' + i,
      staticClass: "tag"
    })
  }), 0)])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('p', {
    staticClass: "loading-text"
  }, [_vm._v(_vm._s(_vm.text))]), _vm._v(" "), _vm._m(2)])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-header"
  }, [_c('div', {
    staticClass: "doc-icon"
  }, [_c('div', {
    staticClass: "icon-inner"
  })]), _vm._v(" "), _c('div', {
    staticClass: "doc-title-wrapper"
  }, [_c('div', {
    staticClass: "doc-title"
  }), _vm._v(" "), _c('div', {
    staticClass: "doc-subtitle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "magnifier-true"
  }, [_c('div', {
    staticClass: "glass"
  }, [_c('div', {
    staticClass: "reflection"
  }), _vm._v(" "), _c('div', {
    staticClass: "crosshair"
  }), _vm._v(" "), _c('div', {
    staticClass: "lens-effect"
  })]), _vm._v(" "), _c('div', {
    staticClass: "handle"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "progress-container"
  }, [_c('div', {
    staticClass: "progress-bar"
  }, [_c('div', {
    staticClass: "progress"
  }), _vm._v(" "), _c('div', {
    staticClass: "progress-highlight"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-561c74b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/loading/searchLoaing.vue
// module id = 1012
// module chunks = 3